import { API_CALL } from '../constants/actionTypes';
import { COUNTRIES } from '../constants/apiTypes';
import { getCountries } from '../api/countries';

export function fetchCountries() {
  // eslint-disable-line import/prefer-default-export
  return {
    type: API_CALL,
    api: COUNTRIES,
    request: getCountries()
  };
}
